import { useSidebar } from "./sidebar-context";

export function SidebarHoverTrigger() {
  const { setIsHovered, state } = useSidebar();
  const isCollapsed = state === "collapsed";

  if (!isCollapsed) return null;

  return (
    <div
      className="fixed left-0 top-0 h-dvh w-5 z-50"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    />
  );
}
